import {
  ButtonsDropdownOption,
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { deleteOppWithDependencies } from "components/Modal/confModalTypes";
import { CAPTURE_TRACKED_OPPS_ROOT } from "constants/routes";
import { modalTypes } from "constants/types";
import { Trash2 } from "lucide-react";
import { bool, number, string } from "prop-types";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideModal, showModal } from "slices/app/actions/modals";
import {
  fetchOppAssociatedData,
  untrackOpportunityById,
} from "slices/opportunity/opportunities/actions";

const UntrackButton = ({
  isManualOpp,
  opportunityId,
  opportunityTitle,
  fromSummary = true,
  asButton = false,
  buttonSize = NewButtonSize.md,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeModal = () => {
    dispatch(hideModal(modalTypes.CONFIRMATION));
  };

  const onUntrack = async () => {
    await dispatch(
      untrackOpportunityById(opportunityId, fromSummary, isManualOpp)
    );
    closeModal();
    if (fromSummary) {
      navigate(CAPTURE_TRACKED_OPPS_ROOT);
    }
  };

  const handleClick = async (e) => {
    if (e) {
      e.stopPropagation();
    }

    const data = await dispatch(fetchOppAssociatedData(opportunityId));
    const localDocumentCount = data?.localDocumentCount;
    const userCreatedDocsCount = data?.userCreatedDocs;
    const amendmentReportCount = data?.amendmentReportCount;
    const shredCount = data?.shredCount;
    const hasProposal = data?.hasProposal;

    const hasDependencies =
      localDocumentCount > 0 ||
      userCreatedDocsCount > 0 ||
      amendmentReportCount > 0 ||
      shredCount > 0 ||
      hasProposal;

    if (hasDependencies) {
      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          deleteOppWithDependencies(
            onUntrack,
            closeModal,
            isManualOpp,
            localDocumentCount,
            userCreatedDocsCount,
            amendmentReportCount,
            shredCount,
            hasProposal,
            opportunityTitle
          )
        )
      );
    } else {
      await onUntrack();
    }
  };

  if (asButton) {
    return (
      <NewButton
        size={buttonSize}
        variant={NewButtonVariant.red}
        onClick={handleClick}
        leftIcon={<Trash2 size={16} />}
      />
    );
  }

  return (
    <ButtonsDropdownOption
      key={"track-opp-details-option1"}
      text={isManualOpp ? "Delete Opp" : "Untrack Opp"}
      content={isManualOpp ? "Delete Opp" : "Untrack Opp"}
      onClick={handleClick}
    />
  );
};

export default UntrackButton;

UntrackButton.propTypes = {
  isManualOpp: bool,
  opportunityId: number,
  opportunityTitle: string,
  fromSummary: bool,
  asButton: bool,
  buttonSize: string,
};
